import { Component, OnDestroy, OnInit, ViewChild, Output,EventEmitter, Input, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { forkJoin, Observable, of, share, Subject, Subscription, takeUntil } from 'rxjs';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { AppGlobalsService } from '../services/app-globals.service';
import { IEditCheck } from '../services/auth-guard.service';
import { SiteDataService } from '../services/site-data.service';
import { IStarbaseNotificationObject, StarbaseNotificationTypes } from 'starbase-notification';
import { STContactDataService } from '../services/st-contact-data.service';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { LU_MaterialService, LU_MaterialServiceDetail, ScaleTicketHeader, LU_STContactType, LU_Grid, LU_JobCategory, LU_JobCode, LU_MaterialSubCategory, LU_STUnitOfMeasure, LU_VehicleType, LU_Tax, LU_InvoiceBatch, STContact, Job, CustomerSelectComponent, StarbaseServicesProviderBase, AppGlobalsServiceBase, ScaleTicketStatusEnum, LU_MaterialServiceServiceBase, Site} from 'scaletech-core';
import { JobDataServiceBase } from 'scaletech-jobs';
import { StarbaseWizardComponent, IStarbaseWizardStep, StarbaseWizardStep } from 'starbase-wizard';
import { ISelectable, FilterParams } from 'starbase-launcher';
import { LU_JobCodeService } from '../services/lookups/lu-job-code.service';
import { LU_GridService } from '../services/lookups/lu-grid.service';
import { LU_ContactTypeService } from '../services/lookups/lu-contact-type.service';
import { LU_JobCategoryService } from '../services/lookups/lu-job-category.service';
import { LU_MaterialServiceService } from '../services/lookups/lu-material-service.service';
import { LU_TaxService } from '../services/lookups/lu-tax.service';
import { LU_UnitOfMeasureService } from '../services/lookups/lu-unit-of-measure.service';
import { LU_VehicleTypeService } from '../services/lookups/lu-vehicle-type.service';
import { VehicleDataService } from '../services/vehicle-data.service';
import { LU_MaterialSubCategoryService } from '../services/lookups/lu-material-sub-category.service';
import { LU_InvoiceBatchService } from '../services/lookups/lu-invoice-batch.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ScaleTicketHeaderServiceBase } from 'scaletech-tickets';
import { stringify } from 'querystring';

@Component({
  selector: 'app-reports-wizard',
  templateUrl: './reports-wizard.component.html',
  styleUrls: ['./reports-wizard.component.css']
})
export class ReportsWizardComponent implements OnInit {
  @Input() darkMode = false;
  @Input() reportTitle = 'Report';
  @Input() jobCodes: LU_JobCode[];
  @Input() jobCategories: LU_JobCategory[];
  @Input() sthSvc: ScaleTicketHeaderServiceBase;
  @Input() contactSvc : STContactDataService;
  @Input() jobSvc: JobDataServiceBase;
  @Input() appGlobals: AppGlobalsServiceBase;
  @Input() sbSvcProvider: StarbaseServicesProviderBase;
  @Input() isSeasonal = false;
  @Input() warnForDateRange = false;
  @ViewChild('customerSelect') customerSelect: CustomerSelectComponent;
  @ViewChild('reportsWizard', { static: true }) reportsWizard: StarbaseWizardComponent<FilterParams<ScaleTicketHeader>>;
  @ViewChild('step1', { static: true }) step1: TemplateRef<FilterParams<ScaleTicketHeader>>;
  @ViewChild('step2', { static: true }) step2: TemplateRef<FilterParams<ScaleTicketHeader>>;
  @ViewChild('step3', { static: true }) step3: TemplateRef<FilterParams<ScaleTicketHeader>>;
  @ViewChild('step4', { static: true }) step4: TemplateRef<FilterParams<ScaleTicketHeader>>;
  @ViewChild('step5', { static: true }) step5: TemplateRef<FilterParams<ScaleTicketHeader>>;
  @Output() wizardCompletedEmitter = new EventEmitter<FilterParams<ScaleTicketHeader>>();
  @Output() wizardCancelledEmitter = new EventEmitter<FilterParams<ScaleTicketHeader>>();

  isAdmin = false;
  private currentUser: IUserTokenModel;
  public dropdownTypeDebounceTime;
  public showAll = true;
  public customersLoaded = true;
  public isProcessing = false;
  public filterParams: FilterParams<ScaleTicketHeader> = new FilterParams<ScaleTicketHeader>();
  public generateTonnageReportSteps: IStarbaseWizardStep<FilterParams<ScaleTicketHeader>>[];
  public filter = new FilterParams;
  statuses: any[] = [];
  materials: any[] = [];
  jobs: Job[] = [];
  allJobs: Job[] = [];
  customers: STContact[] = [];
  allCustomers: STContact[] = [];
  sites: Site[] = [];
  tempCustomers: STContact[] = [];
  tempJobs: Job[] = [];

  selectCustomerMode = false;
  selectJobMode = false;

  private now = new Date();
  private dateCustomClasses = [
    { date: this.now, classes: ['bg-info'] }
  ];
  bsConfig: Partial<BsDatepickerConfig> = {
    isAnimated: true,
    adaptivePosition: true,
    containerClass: 'theme-green',
    showPreviousMonth: true,
    showWeekNumbers: false,
    ranges: [
      {
        value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date()],
        label: 'Today'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999))],
        label: 'Yesterday'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 7 Days'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth() - 6, 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 6 Months'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth(), 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Month To Date'
      },
      {
        value: [new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), new Date()],
        label: 'Year To Date'
      }
    ],
    dateCustomClasses: this.dateCustomClasses
  };

  year = null;
  filterJobCategoryUID = 0;
  filterJobCodeUID = 0;
  filterCustomerUID = 0;
  filterJobUID = 0;
  filterSiteUID = 0;
  filterWeighmaster = '';
  filterStatus: ScaleTicketStatusEnum[] = [];
  filterInvoiceUID = 0;
  filterDateFrom: Date = null;
  filterDateTo: Date = null;
  filterCustomer = '';
  filterMaterial: LU_MaterialService[] = [];

  constructor(public sbCmpMsgSvc: StarbaseComponentMessageService,
               protected modalSvc: StarbaseModalDialogService,
               public jobCodeService: LU_JobCodeService,
               public gridModelService: LU_GridService,
               public contactTypeService: LU_ContactTypeService,
               public jobCategoryService: LU_JobCategoryService,
               public materialsServices: LU_MaterialServiceService,
               public taxModelService: LU_TaxService,
               public uomSvc: LU_UnitOfMeasureService,
               public vehicleTypeSvc: LU_VehicleTypeService,
               public vehicleSvc: VehicleDataService,
               public matSubCategorySvc: LU_MaterialSubCategoryService,
               public siteSvc: SiteDataService,
               public batchSvc: LU_InvoiceBatchService,
               private loginSvc: StarbaseLoginService) { }

  ngOnInit() {
    this.generateTonnageReportSteps = [
      new StarbaseWizardStep(
        'Range Selection',
        this.step1,
        'auto'
      )/*,
      new StarbaseWizardStep(
        'Customer Selection',
        this.step2,
        'auto'
      ),
      new StarbaseWizardStep(
        'Job Selection',
        this.step3,
        'auto'
      ),*/
    ];

    this.generateTonnageReportSteps[0].stepValidationFunc = () => {
      this.generateTonnageReportSteps[0].stepValid$.next(/*!!this.filterDateFrom && !!this.filterDateTo &&*/ this.customersLoaded);
    };
    this.generateTonnageReportSteps[0].interStepFunc = (x: FilterParams<ScaleTicketHeader>) =>{
      //this.generateTonnageReportSteps[1].stepValidationFunc(x);
      return of(void 0);
    }
    /*this.generateTonnageReportSteps[1].stepValidationFunc = () => {
      this.generateTonnageReportSteps[1].stepValid$.next(true);
    }
    this.generateTonnageReportSteps[1].interStepFunc = (x: FilterParams<ScaleTicketHeader>) =>{
      this.generateTonnageReportSteps[2].stepValidationFunc(x);
      return of(void 0);
    }
    this.generateTonnageReportSteps[2].stepValidationFunc = () => {
      this.generateTonnageReportSteps[2].stepValid$.next(true);
    }*/

    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.currentUser = this.loginSvc.getUserModel();
    if (!this.appGlobals.currentUser || this.appGlobals.currentUser !== this.currentUser.user) {
      this.appGlobals.currentUser = this.currentUser.user;
    }

    this.darkMode = this.appGlobals.getStoredDarkModeSetting();

    this.dropdownTypeDebounceTime = this.appGlobals.dropdownTypeDebounceTime;

    if (this.appGlobals.getStoredDarkModeSetting()) {
      this.bsConfig.containerClass = 'theme-default'
    }
    this.statuses = ScaleTicketHeader.GetStatusEnum();
    this.materialsServices.getAllData(this.materialsServices.getAllUri).subscribe(m => {
      if (m && m.length) {
        this.materials = m.filter(x => x.requiresExitWeightInScaleTicket);
      }
    });
    this.jobSvc.getAllData(this.jobSvc.getAllUri).subscribe(j => {
      if (j && j.length) {
        this.allJobs = j;
      }
    });
    this.contactSvc.getCustomers().subscribe(c => {
      if (c && c.length) {
        this.allCustomers = c;
      }
    });
    setTimeout(() => {
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
    }, 500)
  }

  displayDateRangeWarning() {
    return this.warnForDateRange && this.filterDateFrom && this.filterDateTo && Math.floor((this.filterDateTo.getTime() - this.filterDateFrom.getTime()) / 86400000) > 31;
  }

  dateRangeChange(val: Date[]) {
    this.showAll = false;
    this.filterDateFrom = val[0];
    this.filterDateTo = val[1];
    if (this.filterDateFrom != null || this.filterDateTo != null) {
      this.filterDateFrom.setHours(0, 0, 0, 0);
      this.filterDateTo.setHours(23, 59, 59, 999);
    }
    if (this.filterDateFrom > this.filterDateTo) {
      this.sbSvcProvider.notificationSvc.postNotification(
        this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Invalid Date Range',
          'Please enter a valid Date Range'
      ));
    } else {
      // something to change to only customers active in date range
      this.customers = this.customers;
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
    }
    if (this.filterParams == null){
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }
    else{
      this.filterParams.clearFilterArray();
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }
    this.updateCustomers();
    return;
  }

  setYear(){
    var year = (<HTMLInputElement>document.getElementById('year')).valueAsNumber;
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year-1);
    dates[0].setMonth(11);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year);
    dates[1].setMonth(11);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);
    if(year >= 2020 && year <= new Date().getFullYear()){
      this.filterDateFrom = dates[0];
      this.filterDateTo = dates[1];
      if (this.filterParams == null){
        this.filterParams = this.updateGeneralFilters(this.filterParams);
      }
      else{
        this.filterParams.clearFilterArray();
        this.filterParams = this.updateGeneralFilters(this.filterParams);
      }
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
      console.log(this.filterParams);
    }
    return;
  }

  selectCustomer(customer: STContact) {
    this.jobs = undefined;
    if (customer) {
      this.customers=[];
      this.customers.push(customer);
    } else {
      this.customers = [];
    }
    this.jobs = this.allJobs.filter((j) => this.customers.some((c) => c.contactUID === j.jobContactUID));
  }

  selectAllCustomers() {
    this.jobs = undefined;
    this.customers = this.allCustomers;
    this.customers.forEach(x => x.selected = true);
    this.jobs = this.allJobs.filter((j) => this.customers.some((c) => c.contactUID === j.jobContactUID));
    if (this.customerSelect) {
      this.customerSelect.refreshData(this.customerSelect.filter, this.contactSvc.customerBroadSearchUri);
    }
    this.selectCustomerMode = false;
  }

  selectJob(job: Job) {
    if (job === null) {
      this.jobs = [];
    } else if (job.selected) {
      this.jobs.push(job);
    } else {
      this.jobs = this.jobs.filter(x => x.uid !== job.uid);
    }
  }

  updateStatuses(status: ScaleTicketStatusEnum) {
    if (this.filterStatus.includes(status)) {
      this.filterStatus = this.filterStatus.filter(s => s != status);
    } else {
      this.filterStatus.push(status);
    }
    this.updateCustomers();
  }

  updateMaterials(material: LU_MaterialService) {
    if (this.filterMaterial.includes(material)) {
      this.filterMaterial = this.filterMaterial.filter(m => m.uid == material.uid);
    } else {
      this.filterMaterial.push(material);
    }
  }

  updateGeneralFilters(filters: FilterParams<ScaleTicketHeader>){
    this.filterStatus.forEach(x => {
      filters.addToFilter('ScaleTicketStatus', x);
    });
    this.filterMaterial.forEach(x => {
      filters.addToFilter('MaterialUID', x.uid.toString());
    })
    if (this.filterDateFrom && this.filterDateTo) {
      filters.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
      filters.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
    }
    return filters;
  }

  updateCustomerFilters(filters: FilterParams<ScaleTicketHeader>){
    if(this.customers == this.allCustomers){
      return filters;
    }
    else{
      this.customers.forEach(x => {
        filters.addToFilter('Job.JobContactUID', x.contactUID);
      })
    }
    return filters;
  }

  updateCustomers() {
    this.customersLoaded = false;
    this.isProcessing = true;
    var filters = new FilterParams<STContact>();

    filters.rpp = 32760;

    if (this.filterDateFrom && this.filterDateTo) {
      filters.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
      filters.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
    }

    if (this.filterStatus) {
      this.filterStatus.forEach(s => filters.addToFilter('ScaleTicketStatus', s));
      //for(var status in this.filterStatus) {
      //  filters.addToFilter('ScaleTicketStatus', status);
      //}
    }

    const customerSearch$ = this.contactSvc.getDataByFilterParamsBroadSearch(this.contactSvc.customerBroadSearchUri, filters).pipe(share());
    const notifier = this.createAsyncNotification(customerSearch$);
    customerSearch$.subscribe(c => {
      this.customersLoaded = true;
      this.customers = c.collection;
      this.allCustomers = c.collection;
      this.jobs = this.allJobs.filter((j) => this.customers.some((c) => c.contactUID === j.jobContactUID));
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
      this.reportsWizard.detectChanges();
      notifier.updateTitle('Completed');
      this.isProcessing = false;
    });
    this.sbSvcProvider.notificationSvc.postNotification(notifier);
  }

  updateJobFilters(filters: FilterParams<ScaleTicketHeader>){
    if(this.jobs == this.allJobs){
      return filters;
    } else {
      this.jobs.forEach(x => {
        filters.addToFilter('JobUID', x.uid);
      })
    }
    return filters;
  }

  generateReport(filters: FilterParams<ScaleTicketHeader>){
      this.filterParams = this.updateGeneralFilters(filters);
      this.filterParams = this.updateCustomerFilters(this.filterParams);
      this.filterParams = this.updateJobFilters(this.filterParams);
      this.filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
      this.filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());
      console.log(this.filterParams);
      this.wizardCompletedEmitter.emit(this.filterParams);
  }

  private createAsyncNotification(obs: Observable<any>): IStarbaseNotificationObject {
    let title = 'Please wait...';
    if (this.isProcessing) {
      title = 'Processing...';
    }
    return this.sbSvcProvider.notificationSvc.notificationBuilderAsync(
      title,
      null,
      StarbaseNotificationTypes.Notice, // or set undefined and 5th param = StarbaseNotificationSentiment.Notice
      obs
    );
  }

  openCustomerSelection() {
    this.selectCustomerMode = true;
    this.tempCustomers = this.customers;
  }

  closeCustomerSelectComponent(passContact: boolean = false, cust?: STContact) {
    if(!passContact){
      this.customers = this.tempCustomers;
    }
    if(cust){
      this.selectCustomer(cust)
    }
    this.selectCustomerMode = false;
  }

  openJobSelection() {
    this.selectJobMode = true;
    this.tempJobs = this.jobs;
  }

  closeJobSelectComponent(passJobs: boolean = false, job?: Job) {
    if(!passJobs){
      this.jobs = this.tempJobs;
    }
    if(job){
      //Not set to be hit currently
      this.selectJob(job)
    }
    this.selectJobMode = false;
  }
}
